import { render, staticRenderFns } from "./HomePrivateAccess.vue?vue&type=template&id=52335725&scoped=true"
import script from "./HomePrivateAccess.vue?vue&type=script&lang=ts"
export * from "./HomePrivateAccess.vue?vue&type=script&lang=ts"
import style0 from "./HomePrivateAccess.vue?vue&type=style&index=0&id=52335725&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52335725",
  null
  
)

export default component.exports